import React, { useEffect, useState } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}
function getRandomInt(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
export function PricingSection() {
  const [selectedOption, setSelectedOption] = useState('elite');
  const [viewers, setViewers] = useState(getRandomInt(40, 80));
  const [spots, setSpots] = useState(getRandomInt(7, 15));
  const today = new Date().toLocaleDateString('es-AR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  useEffect(() => {
    const viewerInterval = setInterval(() => {
      setViewers(getRandomInt(40, 80));
    }, getRandomInt(30000, 60000));
    const spotsInterval = setInterval(() => {
      setSpots(getRandomInt(7, 15));
    }, getRandomInt(30000, 60000));
    return () => {
      clearInterval(viewerInterval);
      clearInterval(spotsInterval);
    };
  }, []);
  const options = [{
    id: 'base',
    title: 'Pack Base',
    desc: 'Pack principal + 5 bonos estratégicos',
    icon: '📋',
    price: 19990,
    oldPrice: '$49.975 ARS',
    savings: 'Ahorrás 60%',
    url: 'https://checkout.nuvoraplus.online/cart/53229091651952:1',
    oldPriceValue: 49975
  }, {
    id: 'elite',
    title: 'Pack Élite',
    desc: 'Pack principal + 5 bonos + Atlas de Selección + Protocolos de Comunicación',
    icon: '🏆',
    price: 28990,
    oldPrice: '$72.475 ARS',
    savings: 'Ahorrás 60%',
    url: 'https://checkout.nuvoraplus.online/cart/53346292040048:1',
    oldPriceValue: 72475,
    isBest: true,
    savingsAmount: 'AHORRÁS 60%'
  }, {
    id: 'atlas',
    title: 'Pack + Atlas de Selección',
    desc: 'Pack principal + 5 bonos + Atlas de Selección: Matriz de Decisiones Técnicas',
    icon: '🗺️',
    price: 25990,
    oldPrice: '$64.975 ARS',
    savings: 'Ahorrás 60%',
    url: 'https://checkout.nuvoraplus.online/cart/53346361606512:1',
    oldPriceValue: 64975
  }, {
    id: 'protocolos',
    title: 'Pack + Protocolos de Comunicación',
    desc: 'Pack principal + 5 bonos + Protocolos de Comunicación: El Guión del Profesional de Élite',
    icon: '🎙️',
    price: 25990,
    oldPrice: '$64.975 ARS',
    savings: 'Ahorrás 60%',
    url: 'https://checkout.nuvoraplus.online/cart/53346362524016:1',
    oldPriceValue: 64975
  }];
  const selectedData = options.find(opt => opt.id === selectedOption) || options[1];
  const handleCheckoutClick = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: selectedData.title,
        content_type: 'product',
        value: selectedData.price,
        currency: 'ARS'
      });
      window.fbq('track', 'InitiateCheckout', {
        content_name: selectedData.title,
        value: selectedData.price,
        currency: 'ARS'
      });
    }
  };
  return <section id="precio" className="py-12 bg-background-dark relative overflow-hidden" data-id="element-260">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-261">
        <FadeIn className="text-center mb-12" data-id="element-262">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white font-heading mb-2" data-id="element-263">
            Elegí <span className="text-primary" data-id="element-264">tu Pack:</span>
          </h2>
          <p className="text-xl text-gray-400 mt-4" data-id="element-265">
            Todas las opciones incluyen los 5 bonos estratégicos
          </p>
        </FadeIn>

        <div className="space-y-4 mb-10" data-id="element-266">
          {options.map((opt, index) => <FadeIn key={opt.id} delay={0.1 * index} direction="up" data-id="element-267">
              <div onClick={() => setSelectedOption(opt.id)} className={`
                  relative cursor-pointer rounded-2xl p-5 md:p-6 transition-all duration-300
                  flex flex-col md:flex-row items-start md:items-center gap-4
                  ${opt.isBest ? 'bg-card-dark elite-highlight' : selectedOption === opt.id ? 'bg-card-dark border-2 border-primary shadow-[0_0_25px_rgba(217,95,2,0.2)]' : 'bg-card-dark border-2 border-card-border-dark hover:border-primary/50'}
                `} data-id="element-268">
                {opt.isBest && <>
                    <div className="absolute -top-3 left-4 bg-primary text-black text-xs font-bold uppercase tracking-wider py-1 px-3 rounded-full shadow-lg z-10" data-id="element-269">
                      🏆 MÁS ELEGIDO
                    </div>
                    <div className="absolute -top-3 right-4 bg-primary text-black text-xs font-bold uppercase tracking-wider py-1 px-3 rounded-full shadow-lg z-10 hidden sm:block" data-id="element-270">
                      {opt.savingsAmount}
                    </div>
                  </>}

                <div className="flex items-center gap-4 flex-1" data-id="element-271">
                  <div className={`
                    w-6 h-6 rounded-full border-2 shrink-0 flex items-center justify-center transition-all
                    ${selectedOption === opt.id ? 'border-primary' : 'border-gray-500'}
                  `} data-id="element-272">
                    {selectedOption === opt.id && <div className="w-3 h-3 rounded-full bg-primary" data-id="element-273" />}
                  </div>

                  <div className="text-2xl shrink-0" data-id="element-274">{opt.icon}</div>

                  <div data-id="element-275">
                    <h4 className="text-lg md:text-xl font-bold text-white mb-1" data-id="element-276">
                      {opt.title}
                    </h4>
                    <p className="text-sm text-gray-400 leading-relaxed" data-id="element-277">
                      {opt.desc}
                    </p>
                  </div>
                </div>

                <div className="flex flex-row md:flex-col items-center md:items-end justify-between w-full md:w-auto mt-4 md:mt-0 pt-4 md:pt-0 border-t border-card-border-dark md:border-t-0" data-id="element-278">
                  <div className="flex flex-col items-start md:items-end" data-id="element-279">
                    <span className="text-gray-500 line-through text-sm mb-1 notranslate" translate="no" data-id="element-280">
                      {opt.oldPrice}
                    </span>
                    <span className="text-2xl md:text-3xl font-black notranslate text-primary" translate="no" data-id="element-281">
                      ${opt.price.toLocaleString('es-AR')} ARS
                    </span>
                  </div>
                  <span className="bg-primary/20 text-primary px-3 py-1 rounded-full text-xs font-bold mt-2" data-id="element-282">
                    {opt.savings}
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-283">
          {/* Offer block */}
          <div className="bg-[#1A1A1A] border-2 border-primary rounded-3xl p-8 md:p-10 mb-8 shadow-[0_0_30px_rgba(217,95,2,0.15)]" data-id="element-284">
            {/* Offer valid header */}
            <div className="text-center mb-6" data-id="element-285">
              <h3 className="text-2xl md:text-3xl font-black text-primary font-heading uppercase tracking-wider mb-2" data-id="element-286">
                OFERTA VÁLIDA
              </h3>
              <p className="text-white text-sm md:text-base font-bold animate-pulse" data-id="element-287">
                Solo por hoy: {today}
              </p>
            </div>

            {/* Divider */}
            <div className="h-px w-full bg-primary/30 mb-6" data-id="element-288" />

            {/* Crossed out value */}
            <div className="flex flex-col items-center text-center gap-2 mb-6" data-id="element-289">
              <span className="text-gray-500 line-through text-lg md:text-xl font-bold notranslate" translate="no" data-id="element-290">
                VALOR TOTAL REAL: {selectedData.oldPrice}
              </span>

              {/* Dynamic price */}
              <div className="flex items-baseline justify-center gap-2 mt-2" data-id="element-291">
                <span className="text-5xl md:text-7xl font-black text-primary font-heading notranslate" translate="no" data-id="element-292">
                  ${selectedData.price.toLocaleString('es-AR')}
                </span>
                <span className="text-2xl md:text-3xl font-bold text-primary notranslate" translate="no" data-id="element-293">
                  ARS
                </span>
              </div>
            </div>

            {/* CTA Button */}
            <div id="checkout-btn" className="flex flex-col items-center gap-4 mb-6" data-id="element-294">
              <Button fullWidth href={selectedData.url} className="md:py-6 md:text-2xl max-w-xl mx-auto" onClick={handleCheckoutClick} data-id="element-295">
                🎯 → SÍ, QUIERO ENTRENAR CON CRITERIO
              </Button>

              <p className="text-gray-500 text-sm italic text-center max-w-md" data-id="element-296">
                El pago se realiza a través de Mercado Pago.
              </p>

              <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-gray-400" data-id="element-297">
                <span data-id="element-298">🔒 Pago seguro</span>
                <span data-id="element-299">⚡ Acceso en 5 minutos</span>
                <span data-id="element-300">🛡️ Garantía 7 días sin preguntas</span>
              </div>
            </div>

            {/* Social proof */}
            <div className="border border-primary/30 rounded-xl p-4 max-w-sm mx-auto" data-id="element-301">
              <div className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-2.5 items-center" data-id="element-302">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse shrink-0" data-id="element-303" />
                <span className="text-gray-300 text-sm" data-id="element-304">
                  <span className="font-bold text-white" data-id="element-305">{viewers}</span>{' '}
                  personas viendo esta página ahora
                </span>
                <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse shrink-0" data-id="element-306" />
                <span className="text-gray-300 text-sm" data-id="element-307">
                  Quedan <span className="font-bold text-urgency" data-id="element-308">{spots}</span>{' '}
                  cupos con precio promocional
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}